<template>
    <form style="width: 500px; margin: auto; background-color: #8A8D91;">
        <div id="playappinfo" class="modal">
            <div class="modal-content">
                <div class="row">
                    <div class="col offset-s11 s1 modal-close" style="text-align: right;" v-on:click="okClicked()"><i class="material-icons">close</i></div>
                </div>
                Nowa wersja aplikacji jest kompatybilna z <b>testową wersją aplikacji mobilnej MOBIpest</b>.<br/>
                W sklepie Play wybierz aplikację MOBIpest i otwórz informacje o aplikacji.<br/>
                W sekcji „Dołącz do programu testów beta” kliknij <b>Dołącz</b><br/>
                Proces może potrwać do kilkunastu minut. Zarezerwuj czas na tę zmianę. <br/>
            </div>
        </div>
        <img src="https://mobipest.eu/wp-content/uploads/2021/01/mobipest_logo.png" style="width: 500px; height: 75px; margin-bottom: 25px;">
        <div class="row" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-align: right;">
            <div class="col s2" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;">{{ $t('login.email') }} </div>
            <div class="input-field inline col s8" style="margin-top: 0.25rem; margin-bottom: 0.25rem; "><input v-model="email" /></div>
        </div>
        <div class="row" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-align: right;">
            <div class="col s2" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;">{{ $t('login.password') }} </div>
            <div class="input-field inline col s8" style="margin-top: 0.25rem; margin-bottom: 0.25rem; "><input type="password" v-model="password" /></div>
        </div>
        <div style="width: 400px;">
            <div class="row" style="margin-top: 0.25rem; margin-bottom: 0rem; text-align: right;">
                <div class="col offset-s2 s6" style="">
                    <label>
                        <input type="checkbox" />
                        <span style="color: black;">{{ $t('login.remember_me') }}</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-align: left;">
            <div class="col s10" style="">
                <p style="text-align: left; color: #C22026;">{{error}}</p>
            </div>
        </div>
        <div class="row" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-align: right;">
            <div class="col offset-s2 s2" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;">
                <p>
                    <a  href="#/remember" class="waves-effect waves-light btn-large" style="background-color: #DADADA; text-transform: initial; height: 48px;">{{ $t('login.forgot_password') }}</a>
                </p>
                <a v-on:click="log_in()" class="waves-effect waves-light btn-large" :class="{ red: (emailIsValid(email) && password.length > 0) }" style="background-color: #DADADA; font-size: 2em;">
                    <div v-if="logging_in" class="preloader-wrapper small active">
                        <div class="spinner-layer spinner-red-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    {{logging_in == false ? $t('login.log_in') : ""}}
                </a>
            </div>
        </div>
        <div class="row" style="margin-top: 0.25rem; margin-bottom: 0rem; text-align: left;">
            <div class="col s12">
                <p style="text-align: left; margin-bottom: 0px;">{{ $t('login.no_account') }}</p>
            </div>
        </div>
        <div class="row" style="margin-top: 0rem; margin-bottom: 1rem; text-align: right;">
            <div class="col offset-s2 s8" style="text-align: right; margin-top: 0rem;">
                <p>
                    <a href="#/register" class="waves-effect waves-light btn-large" style="background-color: #DADADA; text-transform: initial;">{{ $t('login.register') }}</a>
                </p>
            </div>
        </div>
    </form>
</template>
<script>
import axios from 'axios';
import VueCookies from 'vue-cookies'
export default {
    data: function() {
        return {
            email: "",
            password: "",
            logging_in: false,
            error: ""
        };
    },
    props: ['token'],
    mounted: function(){
        if(this.$parent.logged_in){
            this.$router.push('/desktop');
        }
        if(!this.$cookies.get('okclicked')){
            var elems = document.querySelectorAll('.modal');
            this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true });
            if(!_.isUndefined(this.instances[0])) this.instances[0].open();
        }
        if(_.isNull(this.token) == false){
            this.$router.push('/register');
        }
    },
    methods: {
        log_in: function() {
            this.logging_in = true;
            axios.post('/users/sign_in.json', { "user": { "email": this.email, "password": this.password } })
                .then(response => {
                    this.$emit('logIn', { session: response.data, fresh_session: true });
                })
                .catch(e => {
                    if (e.response.status == 401) {
                        this.$parent.logged_in = false;
                        this.logging_in = false;
                        this.loaded = true;
                        this.error = e.response.data.error;
                    }
                })
        },
        emailIsValid: function(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
        },
        okClicked: function(){
            this.$cookies.set('okclicked', true)
        }
    }
}
</script>
<style scoped>
    .login_button {
        color: red;
    }
    form .btn-large {
        width: 338px;
    }
    .red{
        background-color: #c22026!important;
        border-color: #c22026!important;
    }
    /deep/ .btn-large {
        height: 54px;
        line-height: 54px;
    }
</style>